import React from "react";
import { CardData } from "@/components/layout/element-layout/grid-layout/GridLayout";
import { LogicFlow, deleteLogicFlow } from "@/lib/stores/logicFlowStore";
import { formatRelativeTime } from "@/lib/utils";
import GlossaryWidget from   "@/components/cards/widgets/ObjectsWidget";
import { ItemTypeConfig } from "./types";
import { flowsDataSource } from "@/lib/dataSources/sources/flows";

export const flowsConfig: ItemTypeConfig = {
  type: "flows",
  title: "Logic Flows",
  pageSection: "logic",
  eventName: "addFlow",
  emptyStateTitle: "No Logic Flows",
  emptyStateDescription:
    "No logic flows found for this game. Create your first logic flow to get started.",
  noGameSelectedDescription: "Please select a game to view its logic flows.",

  /**
   * Transform raw items to CardData using the DataSource transformer
   */
  transformData: (
    flows: LogicFlow[],
    tags: any[],
    getUserNameById: (id: string) => string,
    glossaryBlueprints?: any[]
  ): CardData[] => {
    if (!flows || !Array.isArray(flows)) {
      console.warn("transformData: flows is not an array:", flows);
      return [];
    }
    
    // Use DataSource transformer with context
    const cards = flowsDataSource.transformers.toCard?.(flows, {
      tags,
      blueprints: glossaryBlueprints || [],
      getUserNameById,
    }) || [];
    return cards;
  },

  renderCard: (card: CardData, tags: any[]) => {
    return (
      <GlossaryWidget
        id={card.id}
        gameId={card.gameId}
        title={card.title}
        owner={card.owner}
        tags={card.tags}
        description={card.description}
        lastUpdate={card.lastUpdate}
        version={card.version}
        status={card.status}
        folder={card.folder as string}
        itemType="flows"
        icon={card.icon}
        iconBg={card.iconBg}
        shadowType={card.shadowType}
        shadowColor={card.shadowColor}
        hasVersionMismatch={card.hasVersionMismatch}
        onDelete={card.onDelete}
        onEdit={card.onEdit}
      />
    );
  },

  getWizard: (props: any) => {
    // Logic flows don't use a wizard, they use the ReactFlow canvas
    return null;
  },

  handleDelete: async (id: string, gameId: string, toast: any) => {
    await deleteLogicFlow(id, gameId, toast);
  },

  handleCardClick: (card: CardData) => {
    // Navigation handled by hook
  },

  handleAdd: () => {
    // Handled by hook
  },
};

